module.exports = __webpack_public_path__ + "static/media/5.92929ccc.jpg";